import { Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private history: string[] = [];

  constructor(private router: Router, private ngZone: NgZone) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.addToHistory(event.urlAfterRedirects);
      }
    });
  }

  private addToHistory(url: string): void {
    if (this.history.length === 0 || this.history[this.history.length - 1] !== url) {
      this.history.push(url);
    }
  }

  /**
   * Go to a specific route safely (blurs inputs and runs inside Angular zone)
   */
  navigate(path: string | any[], extras: any = {}): void {
    this.blurActiveElement();
    this.ngZone.run(() => {
      this.router.navigate(Array.isArray(path) ? path : [path], extras).catch(err => {
      });
    });
  }

  /**
   * Go to a full URL (used for deep linking)
   */
  navigateByUrl(url: string): void {
    this.blurActiveElement();
    this.ngZone.run(() => {
      this.router.navigateByUrl(url).catch(err => {
      });
    });
  }

  /**
   * Go back to the previous route in history
   */
  goBack(): void {
    if (this.history.length > 1) {
      this.history.pop(); 
      const previousUrl = this.history[this.history.length - 1];
      this.navigateByUrl(previousUrl);
    } else {
      this.navigate(['/']);
    }
  }

  /**
   * Blur active element to prevent iOS freeze
   */
  private blurActiveElement(): void {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && typeof activeElement.blur === 'function') {
      activeElement.blur();
    }
  }
}
